export const actionTypes = {
  // Chabad.org OAuth
  CONNECT_CHABAD_ORG_TRIGGER: "CONNECT_CHABAD_ORG_TRIGGER",
  GET_CHABAD_ORG_STATUS_TRIGGER: "GET_CHABAD_ORG_STATUS_TRIGGER",
  DISCONNECT_CHABAD_ORG_TRIGGER: "DISCONNECT_CHABAD_ORG_TRIGGER",
  SET_CHABAD_ORG_STATUS: "SET_CHABAD_ORG_STATUS",
  SET_INTEGRATIONS_LOADING: "SET_INTEGRATIONS_LOADING",
  SET_INTEGRATIONS_ERROR: "SET_INTEGRATIONS_ERROR",
};

interface ChabadOrgStatus {
  connected: boolean;
  connectedAt?: string;
  salesforceInstanceUrl?: string;
}

interface InitialState {
  chabadOrgStatus: ChabadOrgStatus | null;
  loading: boolean;
  error: string | null;
}

const initialState: InitialState = {
  chabadOrgStatus: null,
  loading: false,
  error: null,
};

type SetChabadOrgStatusAction = {
  type: typeof actionTypes.SET_CHABAD_ORG_STATUS;
  payload: ChabadOrgStatus | null;
};

type SetIntegrationsLoadingAction = {
  type: typeof actionTypes.SET_INTEGRATIONS_LOADING;
  payload: boolean;
};

type SetIntegrationsErrorAction = {
  type: typeof actionTypes.SET_INTEGRATIONS_ERROR;
  payload: string | null;
};


export const integrationsReducer = (
  state = initialState,
  action: any
): InitialState => {
  switch (action.type) {
    case actionTypes.SET_CHABAD_ORG_STATUS:
      return {
        ...state,
        chabadOrgStatus: action.payload,
        loading: false,
        error: null,
      };
    case actionTypes.SET_INTEGRATIONS_LOADING:
      return { ...state, loading: action.payload };
    case actionTypes.SET_INTEGRATIONS_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    default:
      return state;
  }
};

export const integrationsActions = {
  setChabadOrgStatus: (data: ChabadOrgStatus | null): SetChabadOrgStatusAction => ({
    type: actionTypes.SET_CHABAD_ORG_STATUS,
    payload: data,
  }),
  setIntegrationsLoading: (loading: boolean): SetIntegrationsLoadingAction => ({
    type: actionTypes.SET_INTEGRATIONS_LOADING,
    payload: loading,
  }),
  setIntegrationsError: (error: string | null): SetIntegrationsErrorAction => ({
    type: actionTypes.SET_INTEGRATIONS_ERROR,
    payload: error,
  }),
};

export const integrationsTriggerActions = {
  connectChabadOrgTriggerAC: () => ({
    type: actionTypes.CONNECT_CHABAD_ORG_TRIGGER,
  }),
  getChabadOrgStatusTriggerAC: () => ({
    type: actionTypes.GET_CHABAD_ORG_STATUS_TRIGGER,
  }),
  disconnectChabadOrgTriggerAC: () => ({
    type: actionTypes.DISCONNECT_CHABAD_ORG_TRIGGER,
  }),
};
